import styled from 'styled-components'
import {
  textStyleSizeOptions,
  textStyleSizeStyleOptions,
  textStyleWeightOptions,
  textStyleWeightStyleOptions
} from '../../../../fundamentals/text-styles/constants.js'
import colorsOptions from '../../../../fundamentals/colors-styles/constants.js'

export const PaginationSidesContainer = styled.div`
  display: flex;
  gap: 0.5rem;
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-500']]};
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-S']]};
  color: ${colorsOptions.greys['grey-70']};
  min-width: 150px;
`

export const PaginationRightContainer = styled(PaginationSidesContainer)`
  justify-content: flex-end;
`

export const PaginationCenterContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 2px;
`

export const PaginationContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  padding: 0 0.5rem;
`
